import {Injectable} from '@angular/core';
import {IRestApi} from '@app/core/interfaces/rest/i-rest-api';
import {Autowired} from '@angular-ru/autowired';
import {WebUtilities} from '@app/core/utilities/web.utilities';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpResponse} from '@angular/common/http';
import {SgiRestService} from '@app/core/services/sgi/sgi-rest.service';
import {
    API_ACTE_DEMANDE_DETAILS_PRISE_EN_CHARGE,
    API_CALCULER_MONTANT_PRESCRIPTION,
    API_CAN_CLOSE_POURSUITE_PEC,
    API_ENREGISTRER_LES_PRESCRIPTION,
    API_GET_TERME_CONVENTION,
    API_PHARMACIE_PRESCRIPTION_DETAILS_PRISE_EN_CHARGE,
    API_PRESCRIPTION_DETAILS_PERIODIQUE,
    API_RECUPERER_BON_PRESCRIPTION_EN_ATTENTE,
    API_RECUPERER_PRIX_ACTES_POURSUITE
} from '@app/core/constantes';
import {SecurityStateService} from '@app/core/states/security/security.state.service';
import {IUserConnect} from '@app/core/interfaces/user/i-user-connect';
import {DatePipe} from '@angular/common';
import {CommonUtilities} from '@app/core/utilities/common.utilities';

@Injectable({providedIn: 'root'})
export class PrescriptonPecRestApiService extends SecurityStateService implements IRestApi {
    @Autowired() restService: SgiRestService;
    @Autowired() datePipe: DatePipe;
    storageUser: IUserConnect = this.getUser();

    postArgsMute = {successMute: true, errorMute: false, headers: null, params: null};


    requeteCreation(data: any, args?: any): Observable<any> | Promise<any> | any {
        const body = {items: []};
        return of({body: body});
    }

    requeteModification(data: any, args?: any): Observable<any> | Promise<any> | any {
        const body = {items: []};
        return of({body: body});
    }

    requeteRecuperationDonnee(data: any, args?: any): Observable<any> | Promise<any> | any {
        const body = {items: []};
        return of({body: body});
    }

    requeteSuppression(data: any, args?: any): Observable<any> | Promise<any> | any {
        const body = {items: []};
        return of({body: body});
    }


    requeteRecuperationListeDonnees(data: any, args?: any): Observable<any> | Promise<any> | any {
        let sendData = {
            itemToSearch: data,
        };

        if (!CommonUtilities.isDataNullUndefinedFalseEmpty(args)) {
            sendData = {...sendData, ...args.getAllRequestParam};
        }

        // tslint:disable-next-line:max-line-length
        return this.restService.postRequest(`${WebUtilities.baseUrlApi()}${API_RECUPERER_BON_PRESCRIPTION_EN_ATTENTE}`, sendData, {...this.postArgsMute})
            .pipe(
                map((response: HttpResponse<any>) => {
                    if (response.body.items.length !== 0) {
                        response.body.items.forEach((item, index) => {
                            item.id_key = index + 1;
                        });
                        return response;
                    }
                    return response;
                })
            );
    }

    requeteRecuperationListeDonneesPrescription(data: any, args?: any): Observable<any> | Promise<any> | any {
        const sendData = {
            itemToSearch: data,
            TakeAll: true,
        };

        // tslint:disable-next-line:max-line-length
        return this.restService.postRequest(`${WebUtilities.baseUrlApi()}${API_PHARMACIE_PRESCRIPTION_DETAILS_PRISE_EN_CHARGE}`, sendData, {...this.postArgsMute})
            .pipe(
                map((response: HttpResponse<any>) => {
                    if (!(response.body.items.length > 0)) {
                        return response;
                    }
                    return response;
                })
            );
    }

    requeteRecuperationMaxMontantPrescription(data: any, args?: any): Observable<any> | Promise<any> | any {
        const sendData = {itemToSearch: data};

        // tslint:disable-next-line:max-line-length
        return this.restService.postRequest(`${WebUtilities.baseUrlApi()}${API_GET_TERME_CONVENTION}`, sendData, {...this.postArgsMute})
            .pipe(
                map((response: HttpResponse<any>) => {
                    if (!(response.body.items.length > 0)) {
                        return response;
                    }
                    return response;
                })
            );
    }

    requeteRecuperationListeDonneesPrescriptionPeriodique(data: any, args?: any): Observable<any> | Promise<any> | any {
        const sendData = {itemToSearch: data};

        // tslint:disable-next-line:max-line-length
        return this.restService.postRequest(`${WebUtilities.baseUrlApi()}${API_PRESCRIPTION_DETAILS_PERIODIQUE}`, sendData, {...this.postArgsMute})
            .pipe(
                map((response: HttpResponse<any>) => {
                    if (!(response.body.items.length > 0)) {
                        return response;
                    }
                    return response;
                })
            );
    }

    requeteCalculPrescription(data: any, args?: any): Observable<any> | Promise<any> | any {
        const sendData = {ItemsToSave: [data]};

        // tslint:disable-next-line:max-line-length
        return this.restService.postRequest(`${WebUtilities.baseUrlApi()}${API_CALCULER_MONTANT_PRESCRIPTION}`, sendData, {...this.postArgsMute})
            .pipe(
                map((response: HttpResponse<any>) => {
                    if (!(response.body.items.length > 0)) {
                        return response;
                    }
                    return response;
                })
            );
    }

    requeteEnregistrerPrescription(data: any, args?: any): Observable<any> | Promise<any> | any {
        const sendData = {
            bloqued: true,
            ItemsToSave: data
        };

        return this.restService.postRequest(`${WebUtilities.baseUrlApi()}${API_ENREGISTRER_LES_PRESCRIPTION}`, sendData)
            .pipe(
                map((response: HttpResponse<any>) => {
                    if (!(response.body.items.length > 0)) {
                        return response;
                    }
                    return response;
                })
            );
    }

    requeteRecuperationActesPoursuite(data: any, args?: any): Observable<any> | Promise<any> | any {
        // update du paramètre
        data.SortOrder = null;
        const {adherant} = args;

        const sendData = {
            ...data,
            itemToSearch: {
                ...data.itemToSearch,
                idDemandePriseEnCharge: adherant.idDemandePriseEnCharge,
            },
            Size: 20,
            TakeAll: false,
        };
        // tslint:disable-next-line:max-line-length
        return this.restService.postRequest(`${WebUtilities.baseUrlApi()}${API_ACTE_DEMANDE_DETAILS_PRISE_EN_CHARGE}`, sendData, {...this.postArgsMute});
    }

    requeteActionCanClosePoursuite(data: any, args?: any): Observable<any> | Promise<any> | any {
        const {actePoursuite} = args;

        const sendData = {
            ItemsToSave: actePoursuite,
        };
        return this.restService.postRequest(`${WebUtilities.baseUrlApi()}${API_CAN_CLOSE_POURSUITE_PEC}`, sendData, {...this.postArgsMute});
    }

    requeteRecuperationPrixActesPoursuite(data: any, args?: any): Observable<any> | Promise<any> | any {
        const {actePoursuite} = args;

        const sendData = {
            ItemsToSave: actePoursuite,
        };
        // tslint:disable-next-line:max-line-length
        return this.restService.postRequest(`${WebUtilities.baseUrlApi()}${API_RECUPERER_PRIX_ACTES_POURSUITE}`, sendData, {...this.postArgsMute});
    }

}
